
<template>
  <div class="transaction-config">
    <!-- 使用 v-if 确保 $t 返回有效值 -->
    <header-nav v-if="$t('pages_router_062')" :content="$t('pages_router_062')" />
    <!-- 或者使用默认值 -->

    <a-button type="primary" @click="showModal">{{ $t('pages_router_062') }}</a-button>

    <!-- 数据表格 -->
    <a-table :data-source="tableData" :columns="columns" row-key="id" :pagination="false" :scroll="{ x: 1200 }">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'state'">
          <span>{{ record.state === '0' ? $t('pages_user_136') : (record.state === '1' ? $t('pages_user_137') : $t('pages_user_138')) }}</span>
        </template>
        <template v-if="column.key === 'action'">
          <a-button @click="handleAudit(record, '1')">{{ $t('pages_receive_214') }}</a-button>
          <a-button danger @click="handleAudit(record, '2')">{{ $t('pages_receive_215') }}</a-button>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <a-pagination
        :current="formState.searchQuery.pageNum"
        :page-size="formState.searchQuery.pageSize"
        :total="total"
        :show-total="total => `共 ${total} 条记录`"
        show-size-changer
        show-quick-jumper
        @change="updatePage"
        @showSizeChange="updatePageSize"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <a-modal v-model:visible="visible" :title="modalTitle" @ok="handleSubmit">
      <a-form :model="formState" :label-col="{ span: 6 }">
        <a-form-item :label="$t('pages_receipt_096')" required>
          <a-select v-model:value="formState.type" @change="handleTypeChange">
            <a-select-option value="RDR">RDR</a-select-option>
            <a-select-option value="Ethoca">Ethoca</a-select-option>
          </a-select>
        </a-form-item>

        <!-- 公共字段 -->
        <a-form-item :label="$t('pages_receipt_095')" required>
          <a-input v-model:value="formState.descrpptor" />
        </a-form-item>

        <!-- RDR专属字段 -->
        <template v-if="formState.type === 'RDR'">
          <a-form-item :label="$t('pages_receipt_067')" required>
            <a-input v-model:value="formState.acquireBin" />
          </a-form-item>
          <a-form-item :label="$t('pages_receipt_087')">
            <a-input v-model:value="formState.caid" />
          </a-form-item>
          <a-form-item :label="$t('pages_receipt_094')">
            <a-input v-model:value="formState.refundRule" />
          </a-form-item>
          <a-form-item :label="$t('pages_receipt_093')">
            <a-input v-model:value="formState.mcc" />
          </a-form-item>
          <a-form-item :label="$t('pages_receipt_062')">
            <a-input v-model:value="formState.arn" />
          </a-form-item>
        </template>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { _home } from '@/api/index'
import i18n from '@/locale'

export default {
  name: 'RdrAndEthNewAdd',
  setup() {
    const columns = [
      { key: 'id', dataIndex: 'id', title: i18n.global.t('pages_receipt_055'), width: 180, ellipsis: true },
      { key: 'type', dataIndex: 'type', title: i18n.global.t('pages_account_014'), width: 180, ellipsis: true },
      { key: 'descrpptor', dataIndex: 'descrpptor', title: i18n.global.t('pages_receipt_095'), width: 180, ellipsis: true },
      { key: 'acquireBin', dataIndex: 'acquireBin', title: i18n.global.t('pages_receipt_067'), width: 180, ellipsis: true },
      { key: 'caid', dataIndex: 'caid', title: i18n.global.t('pages_receipt_087'), width: 180, ellipsis: true },
      { key: 'refundRule', dataIndex: 'refundRule', title: i18n.global.t('pages_receipt_094'), width: 180, ellipsis: true },
      { key: 'mcc', dataIndex: 'mcc', title: i18n.global.t('pages_receipt_093'), width: 180, ellipsis: true },
      { key: 'arn', dataIndex: 'arn', title: i18n.global.t('pages_receipt_062'), width: 180 },
      { key: 'state', dataIndex: 'state', title: i18n.global.t('pages_receive_068'), width: 180 }
      // { key: 'action', dataIndex: 'action', title: i18n.global.t('pages_exchange_056'), width: 180 }
    ]

    const visible = ref(false)
    const tableData = ref([])
    const modalTitle = ref('新增配置')
    const total = ref(0)

    const formState = reactive({
      type: 'RDR',
      acquireBin: '',
      caid: '',
      refundRule: 'ALL',
      mcc: '',
      arn: '',
      descrpptor: '',
      state: '',
      fee_currency: 'USD',
      fee: null,
      searchQuery: {
        pageNum: 1,
        pageSize: 10
      }
    })

    // 重置表单状态
    const resetFormState = () => {
      formState.acquireBin = ''
      formState.caid = ''
      formState.refundRule = 'ALL'
      formState.mcc = ''
      formState.arn = ''
      formState.descrpptor = ''
      formState.state = '0'
      formState.fee_currency = 'USD'
      formState.fee = null
    }

    // 加载数据
    const loadData = async () => {
      try {
        const resMerchant = await _home.getMerchantInfo()
        if (resMerchant.data.succ) {
          const { merchantNo } = resMerchant.data.data
          formState.merchantNo = merchantNo
          console.log(status)
        }
        const query = Object.assign({}, formState.searchQuery, {
          pageNo: formState.searchQuery.pageNum,
          pageSize: formState.searchQuery.pageSize,
          merchantNo: formState.merchantNo
        })
        const res = await _home.selectAllRDRorEthoca(query)
        tableData.value = res.data.data.results // 将返回的数据中的 results 赋值给 tableData
        total.value = res.data.data.totalRecord // 设置总记录数
        console.log(res)

        console.log('total', total.value)
        console.log(tableData.value)
      } catch (error) {
        message.error('数据加载失败')
      }
    }

    // 显示弹窗
    const showModal = () => {
      resetFormState()
      visible.value = true
    }

    // 提交表单
    const handleSubmit = async () => {
      try {
        console.log(formState)
        await _home.addRDRorEthoca(formState)
        message.success('操作成功')
        visible.value = false
        loadData()
      } catch (error) {
        message.error('操作失败')
      }
    }

    // 审核操作
    const handleAudit = async (record, action) => {
      try {
        const query = Object.assign({}, formState.searchQuery, {
          state: action,
          id: record.id
        })
        const res = await _home.updateRDRorEthoca(query)
        console.log('handleSubmit.res:', res)
        message.success('审核操作成功')
        loadData()
      } catch (error) {
        message.error('操作失败')
      }
    }

    // 更新分页
    const updatePage = (page) => {
      formState.searchQuery.pageNum = page
      loadData()
    }

    // 更新分页大小
    const updatePageSize = (current, size) => {
      formState.searchQuery.pageSize = size
      loadData()
    }

    onMounted(() => {
      loadData()
    })

    return {
      columns,
      visible,
      tableData,
      modalTitle,
      total,
      formState,
      resetFormState,
      loadData,
      showModal,
      handleSubmit,
      handleAudit,
      updatePage,
      updatePageSize
    }
  }
}
</script>

<style scoped>.transaction-config {
  padding: 20px;
}

.ant-table {
  margin-top: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
